import { Delta } from "quill/core";
import { MeetingMinutesAITemplateForm } from "./MeetingMinutesAITemplateForm";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@repo/ui/components/Base/Dialog";
import { MEETING_MOTIF } from "@/lib/constants";
import type { AIMinutesTemplateDto } from "@/repositories/aiMinutesTemplateRepo";

export const MeetingMinutesAITemplateDialog = ({
  open,
  setOpen,
  showDelete,
  aiMinutesTemplate,
  onSubmit,
  onDelete,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  showDelete?: boolean;
  aiMinutesTemplate?: AIMinutesTemplateDto;
  onSubmit?: (name: string, data: Delta) => void | Promise<void>;
  onDelete?: (aiMinutesTemplate: AIMinutesTemplateDto) => void | Promise<void>;
}) => {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        preventClickout
        preventEscape
        className="relative top-[-50vh] overflow-visible"
      >
        <DialogHeader className={MEETING_MOTIF}>
          <DialogTitle>Meeting Minutes Editor</DialogTitle>
        </DialogHeader>
        <MeetingMinutesAITemplateForm
          aiMinutesTemplate={aiMinutesTemplate}
          showDelete={showDelete}
          onCancel={() => setOpen(false)}
          onSubmit={async (name, data) => {
            await onSubmit?.(name, data);
            setOpen(false);
          }}
          onDelete={async (template) => {
            await onDelete?.(template);
            setOpen(false);
          }}
          withinDialog
        />
      </DialogContent>
    </Dialog>
  );
};
